// Cross-evidence: edges where a pedigree family-level finding (a syndrome)
// corroborates a Phenomizer Profile-Match disease/gene. Pure matcher — the
// caller supplies the already-computed client-side Profile Match.
//
// This is the FAMILY-PATTERN "family + variant" signal, deliberately distinct
// from Phenomizer Phase A's gene-holding "gene + phenotype" convergence chip
// (plan §12.2) — they target different evidence and must not double up.

import { CONFIDENCE } from '../constants';

export function detectCrossEvidence(analysisResult, profileMatch = {}) {
  const edges = [];
  const pmDiseaseIds = new Set((profileMatch.diseases || []).map((d) => d.id));
  const pmGeneSymbols = new Set(
    (profileMatch.genes || []).map((g) =>
      String(g.name || g.id || '').toUpperCase()
    )
  );
  const syndromes =
    (analysisResult.family && analysisResult.family.syndromes) || [];

  for (const s of syndromes) {
    if (s.ruledOut || s.confidence === CONFIDENCE.ruledOut) continue;
    for (const did of s.relatedDiseaseIds || []) {
      if (pmDiseaseIds.has(did)) {
        edges.push({
          source: { section: 'pedigree_match', resultId: s.id },
          target: {
            section: 'profile_match',
            resultType: 'disease',
            resultId: did
          },
          strength: s.confidence,
          chipLabel: 'family + variant'
        });
      }
    }
    for (const gene of s.relatedGenes || []) {
      if (pmGeneSymbols.has(String(gene).toUpperCase())) {
        edges.push({
          source: { section: 'pedigree_match', resultId: s.id },
          target: {
            section: 'profile_match',
            resultType: 'gene',
            resultId: gene
          },
          strength: s.confidence,
          chipLabel: 'family + variant'
        });
      }
    }
  }
  return edges;
}
